module.exports = __webpack_public_path__ + "static/img/1_2_2_3.64f3f438.jpg";